import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'

import * as S from './info-row.styled'
import { InfoRowProps } from './info-row.types'

// Note: It's base component for displaying information used in cards, modals and tables
export const InfoRow = ({ title, subtitle, icon, avatar, grayTitle = false }: InfoRowProps) => {
  return (
    <S.Container>
      {icon && <Icon icon={icon} size="2.4rem" />}
      {avatar}
      <S.Content>
        <Typography
          as="span"
          color={grayTitle ? 'black600' : 'black800'}
          size="text-small"
          weight={grayTitle ? 'semibold' : 'medium'}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography as="span" color="black500" size="text-small" weight="medium">
            {subtitle}
          </Typography>
        )}
      </S.Content>
    </S.Container>
  )
}
